import styled from 'styled-components';

import { Button } from '@riac/design-system';
import { MarkdownContentArea } from '@riac/design-system';
import { Panels } from '@riac/design-system';
import { Comments } from 'src/components/Comments/Comments';

export const GhostPostSinglePanels = styled(Panels)``;
export const GhostPostSingleComments = styled(Comments)`
`;
export const UsePrintButtonMessage = styled.div`
  display: none;
  font-size: 2em;
  text-align: center;
  font-weight: bold;
  margin-top: 2em;

  div {
    font-size: 4em;
  }
`;

export const GhostPostSingleContainer = styled.div<{printButtonUsed: boolean}>`
  @media print {
    ${GhostPostSinglePanels}, ${GhostPostSingleComments} {
      display: none;
    }

    ${({ printButtonUsed }) => !printButtonUsed && `
      > * {
        display: none;
      }
      
      ${UsePrintButtonMessage} {
        display: block;
      }
    `}
  }
`;

export const PictureContainer = styled.span`
  display: grid;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: rgba(255, 255, 255, 0.05);
  /* border: solid 2px white; */

  picture {
    width: 100%;
    margin: auto;
  }
`;

export const Content = styled(MarkdownContentArea)`
  padding-top: 100px;

  ul > li > a {
    display: inline-block;
    min-height: 44px;
    ${(props) => props.theme.desktop} {
      min-height: auto;
    }
  }

  @media print {
    column-count: 2;
  }
`;

export const BlogImageButton = styled(Button)`
  display: flex;
`;
